import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { getPageName } from '../../../utils/pageName';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import styles from './login_modal_footer.module.scss';

export const LoginModalFooter: FC = () => {
  const sourcePage: string = getPageName();

  return (
    <footer className={styles.footer}>
      <FormattedMessage id="LoginModalFooter.tsx/1" />{' '}
      <Hyperlink
        href={buildUrlWithParameters('/inscription', {
          source: 'login',
          sourcePage,
        })}
      >
        <FormattedMessage id="LoginModalFooter.tsx/2" />
      </Hyperlink>
    </footer>
  );
};
